// extracted by mini-css-extract-plugin
module.exports = {"TextInput":"styles_TextInput__1cr4j"};